import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../common/Footer";
import { baseUrl } from "../../Utility/constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Form } from "react-bootstrap";
import StudentHeader from "../common/StudentHeader";

const StudentProfile = () => {
  const [userData, setUserData] = useState({
    id: 0,
    schoolId: 0,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: ""
  });

  const loggedUserId = localStorage.getItem("userID"); // You can replace this with dynamic ID as per your use case
  const loggedUserRole = localStorage.getItem("Role");
  const adminApiUrl = `${baseUrl}/api/Admin/GetAdminDetailsByUserId?id=${loggedUserId}`;
  const studentApiUrl = `${baseUrl}/api/PersonalDetails/PersonalDetailsByStudent?StudentId=${loggedUserId}`;

  useEffect(() => {
    fetchAdminProfile();
  }, []);

  const fetchAdminProfile = async () => {
    try {
      const response = await axios.get(loggedUserRole === "ADMIN" ? adminApiUrl : studentApiUrl );
      if(loggedUserRole === "ADMIN"){
      setUserData({
        id: response.data.id,
        schoolId: response.data.schoolId,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        email: response.data.email,
        phone: response.data.phone,
        password: response.data.password,
      });
    }
    if(loggedUserRole === "STUDENT"){
      setUserData({
        id: response.data[0].studentId,
        schoolId: response.data[0].schoolId,
        firstName: response.data[0].firstName,
        lastName: response.data[0].lastName,
        email: response.data[0].studentEmail,
        phone: response.data[0].studentContactNumber,
        password: response.data[0].password,
      });
    }      
    } catch (error) {
      console.log("Failed to fetch admin profile");
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setAdminData({ ...adminData, [name]: value });
  // };

  // const handleUpdateProfile = async () => {
  //   try {
  //     await axios.put(apiUrl, adminData);
  //     toast.success("Profile updated successfully");
  //   } catch (error) {
  //     toast.error("Failed to update profile");
  //   }
  // };

  return (
    <>
      <StudentHeader />
      <div className="container mt-5">
        <h2>User Profile</h2>
        <Form>
          <Form.Group controlId="firstName">
            <Form.Label>First Name</Form.Label> : <Form.Label>{userData.firstName}</Form.Label>
          </Form.Group>

          <Form.Group controlId="lastName">
            <Form.Label>Last Name</Form.Label> : <Form.Label>{userData.lastName}</Form.Label>
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label> : <Form.Label>{userData.email}</Form.Label>
          </Form.Group>

          <Form.Group controlId="phone">
            <Form.Label>Phone</Form.Label> : <Form.Label>{userData.phone}</Form.Label>
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label> : <Form.Label>{userData.password}</Form.Label>
          </Form.Group>

         
        </Form>
      </div>

      <ToastContainer />
      <Footer />
    </>
  );
};

export default StudentProfile;
